import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataElementsTable from './DataElementsTable';
import TaskInformationTable from './TaskInformationTable';
import Notes from './Notes';
import DocumentsTable from './DocumentsTable';
import LegalApprovalTable from './LegalApprovalTable';
//import Questionnaire from './Questionnaire';

const getDisplayValue = (value) => value || '--';

const TASK_INFORMATION_KEYS = ['task_description', 'created_date', 'poc_name', 'due_date', 'priority'];

const useStyles = makeStyles(() => ({
    tabBox: {
        width: '100%',
        backgroundColor: '#8CC0E0'
    },
    tabs: {
        borderBottom: 1,
        borderColor: 'divider',
        height: '5.5vh',
        minHeight: '5.5vh',
        '& .MuiTabs-flexContainer': {
            gap: '4px',
            width: '100%',
            backgroundColor: '#fff'
        },
        '& .MuiTab-root': {
            flex: '1 1 0',
            height: '5.5vh',
            minHeight: '5.5vh',
            border: '2px solid #C4D2E2',
            minWidth: 0,
            maxWidth: 'none',
            backgroundColor: '#8CC0E0',
            opacity: 1,
            color: 'black',
            //border: 1,
            borderColor: 'divider',
            '&.Mui-selected': {
                backgroundColor: '#fff',
                color: 'black',
                border: '2px solid #C4D2E2',
            }
        }
    },
    tabIndicator: {
        backgroundColor: 'red',
        height: '3px'
    },
    tab: {
        minWidth: 0,
        maxWidth: 'none',
        padding: '12px 8px',
        textTransform: 'initial'
    },
    taskInformation: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '35px',
        padding: '17px 10px 15px 30px',
        justifyContent: 'space-between'
    },
    taskInformationItem: {
        width: '130px',
        flex: '0 0 160px',
        '& h6': {
            marginBottom: '8px',
            //lineHeight: '0.8rem'
        },
        '& p': {
            margin: 0
        }
    },
    taskDescriptionItem: {
        width: '220px',
        flex: '0 0 230px',
        '& h6': {
            fontSize: '1rem'
        },
        '& p': {
            lineHeight: '1.1rem'
        }
    },
    taskDescriptionValue: {
        width: '220px',
        height: '54px',
        margin: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        whiteSpace: 'normal',
        wordBreak: 'break-word'
    }
}));

export default function CustomTabs({ taskInformation = [], taskUpdateRows = [], taskId, onUpdateSuccess }) {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const visibleTaskInformation = taskInformation.filter((item) => TASK_INFORMATION_KEYS.includes(item.key));

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setActiveTab(newValue);
    };

    return (
        <div>
            <Box className={classes.tabBox}>
                <Tabs
                    className={classes.tabs}
                    value={value}
                    onChange={handleChange}
                    variant="fullWidth"
                    aria-label="custom tabs example"
                    TabIndicatorProps={{
                        className: classes.tabIndicator
                    }}
                >
                    <Tab
                        label="Task Information"
                        className={classes.tab}
                    />
                    <Tab label="Questionnaire" className={classes.tab} />
                    <Tab label="Data Elements" className={classes.tab} />
                    <Tab label="Notes" className={classes.tab} />
                    <Tab label="Documents" className={classes.tab} />
                    <Tab label="P&G/Legal Approval" className={classes.tab} />
                </Tabs>
            </Box>
            <div>
                {activeTab === 0 &&
                    <div>
                        <div className={classes.taskInformation}>
                            {visibleTaskInformation.map((item) => (
                                <div className={`${classes.taskInformationItem} ${item.key === 'task_description' ? classes.taskDescriptionItem : ''}`} key={item.key}>
                                    <h6>{item.label}</h6>
                                    <p className={item.key === 'task_description' ? classes.taskDescriptionValue : undefined}>{getDisplayValue(item.result)}</p>
                                </div>
                            ))}
                            {visibleTaskInformation.length === 0 && <div>No task information found.</div>}
                        </div>
                        <TaskInformationTable taskUpdateRows={taskUpdateRows} taskId={taskId} onUpdateSuccess={onUpdateSuccess} />
                    </div>
                }
                {activeTab === 1 && <div className={classes.taskInformation}>
                    {/* <div>
                        <Questionnaire key={taskId} taskId={taskId} />
                    </div> */}
                </div>}
                {activeTab === 2 && <div>
                    <DataElementsTable key={taskId} taskId={taskId} />
                </div>}
                {activeTab === 3 && <div className={classes.taskInformation}>
                    <div>
                        <Notes taskId={taskId} />
                    </div>
                </div>}
                {activeTab === 4 &&
                    <div>
                        <DocumentsTable key={taskId} taskId={taskId} />
                    </div>
                }
                {activeTab === 5 && <div>
                    <LegalApprovalTable key={taskId} taskId={taskId} />
                </div>}
            </div>
        </div>
    );
}
